import React from "react";
import Token from "./token";
import User from "./user";
import Roles from "./roles";

const Authorization = ({ connectedMenuId, children }) => {
    return <Roles connectedMenuId={connectedMenuId}>{children}</Roles>;
};

export default Authorization;
